let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dhRfv")).then(() => parcelRequire('1LBPs'));